import * as React from 'react';
import DebugOverlay from "../../containers/DebugOverlay";
import DefaultLayout from "./DefaultLayout";

const DebugLayout = ( props: { serverTime: string, matchid: number } ) => (
    <div>
        <DebugOverlay />
        <DefaultLayout serverTime={props.serverTime} matchid={props.matchid} />
    </div>
)

export default DebugLayout;
